import React, { useRef, useState, useEffect } from 'react';
import Chat, { Bubble, useMessages, Typing, RichText } from '@chatui/core';
import '@chatui/core/dist/index.css';
import 'antd/dist/reset.css';
import './App.css';
import { notification } from 'antd';
import { deepseekService } from '@/services/deepseek';
import { kfApiService } from '@/api/kf';
var wx = require('jweixin-module')
//客服头像
const defaultUser = {
    userAI: {
        avatar: 'https://gnyshshop.oss-cn-guangzhou.aliyuncs.com/upload/3/20241028/bf9c6d86f4501b1f39238335d99b54fe.jpg',
    },
}


const initialMessages = [
    {
        type: 'system',
        content: { text: '悦生活会员专属智能客服【小悦】为您服务' },
    },
    {
        type: 'text',
        content: { text: 'Hi，我是你的专属智能助理小悦，有问题请随时找我哦~' },
        user: defaultUser.userAI
    },
];



const defaultQuickReplies = [
    //   {
    //     icon: 'message',
    //     name: '联系人工服务',
    //     isNew: true,
    //     isHighlight: true,
    //   },
    {
        name: '查物流',
        isHighlight: true,
    },
    {
        name: '产品推荐',
        isHighlight: true,
    },
    {
        icon: 'message',
        name: '联系人工客服',
        isHighlight: true,
    }
];

export default function () {
    const { messages, appendMsg, prependMsg, resetList, deleteMsg } = useMessages(initialMessages);
    const [isTyping, setIsTyping] = useState(false);
    const [isWxReady, setIsWxReady] = useState(false);
    let _conversationId = useRef(null);

    useEffect(() => {
        // 微信JS-SDK初始化
        const initWechatSDK = async () => {
            try {
                // 从后端API获取配置参数
                const url = window.location.href.split('#')[0];
                const res = await kfApiService.getJsSdkSign({ url: url });
                console.log(res);
                const { appId, timestamp, nonceStr, signature } = res.data;
                // 配置微信JS-SDK
                let parms = {
                    debug: false, // 生产环境建议关闭调试
                    appId: appId,
                    timestamp: timestamp,
                    nonceStr: nonceStr,
                    signature: signature,
                    jsApiList: ['navigateToMiniProgram', 'navigateBackMiniProgram', 'chooseWXPay']
                }
                console.log("parms", parms);
                wx.config(parms);

                // 验证配置结果
                wx.ready(() => {
                    console.log('微信JS-SDK初始化成功');
                    // 验证核心API是否存在
                    wx.checkJsApi({
                        jsApiList: parms.jsApiList,
                        success: (res) => {
                            console.log('checkJsApi success:', res);
                        },
                        fail: (res) => {
                            console.error('checkJsApi fail:', res);
                        }
                    });
                    setIsWxReady(true);
                });
                wx.error((err) => {
                    console.error('微信JS-SDK初始化失败:', err);
                    notification.error({ message: '微信SDK初始化失败', description: err.errMsg });
                });
            } catch (error) {
                console.error('获取微信配置参数失败:', error);
                notification.error({ message: '获取微信配置失败', description: error.message });
            }
        };

        // 仅在微信环境中初始化SDK
        if (typeof wx !== 'undefined') {
            initWechatSDK();
        }
    }, []);

    /**
     * 发送消息
     * @param {string} type 消息类型
     * @param {*} val 消息内容
     * @returns {void}
     * @example handleSend('text', 'Hello')
     * */
    async function handleSend(type, val) {
        if (type === 'text' && val.trim()) {
            appendMsg({
                type: 'text',
                content: { text: val },
                position: 'right',
            });
            // 显示输入指示器
            setIsTyping(true);
            // 添加 typing 消息
            appendMsg({
                _id: "typing",
                type: 'typing',
                user: defaultUser.userAI,
            });
            //获取提示内容
            let systemMessage = [
                { role: "system", content: "你是一个专业的客服助手，会为用户提供准确、及时的帮助。" },
            ];
            let resp = await kfApiService.docsearch({ key: val });
            let sendAI = true;
            let respMessage;
            if (resp.msg == 'AI_ASK') {
                sendAI = true;
            } else if (resp.data || resp.msg) {
                // 模拟客服延迟回复
                await new Promise(resolve => setTimeout(resolve, 500));
                //直接返回查询到的结果
                sendAI = false;
                // 检查是否需要跳转小程序
                if (resp.data && resp.data.miniProgram) {
                    respMessage = {
                        type: 'miniProgram',
                        content: {
                            appId: resp.data.miniProgram.appId,
                            path: resp.data.miniProgram.path,
                            title: resp.data.miniProgram.title
                        },
                        user: defaultUser.userAI
                    };
                } else {
                    respMessage = {
                        type: 'html',
                        content: { html: resp.msg, data: resp.data },
                        user: defaultUser.userAI
                    };
                }
            }
            if (sendAI) {
                // 使用 SDK 发送消息
                let userMessage = resp.msg == 'AI_ASK' ? resp.data : val;
                const { reply, conversationId } = await deepseekService.sendMessage(
                    userMessage,
                    _conversationId,
                    systemMessage
                )
                respMessage = {
                    type: 'text',
                    content: { text: reply },
                    user: defaultUser.userAI
                }
                _conversationId = conversationId;
            }

            // 移除 typing 消息并添加回复
            // const newMessages = messages.filter(msg => msg.type !== 'typing');
            deleteMsg('typing');
            appendMsg(respMessage);
            setIsTyping(false);
        }
    }
    // 点击快捷回复
    function handleQuickReplyClick(item) {
        if (isTyping) {
            return;
        }
        if (item.name === '联系人工客服') {
            let kfUrl = "人工客服";
            handleSend('text', kfUrl);
        } else {
            handleSend('text', item.name);
        }
    }

    function handleNavigateToMiniProgram(appId, path) {
        // 检查是否在微信环境中
        if (typeof wx === 'undefined') {
            console.error('微信环境未检测到');
            return;
        }

        // 检查是否是小程序web-view环境
        wx.miniProgram.getEnv((res) => {
            if (res.miniprogram) {
                // 在小程序web-view中，直接跳转
                wx.miniProgram.navigateTo({
                    url: path  // 只需要传path，不需要appId
                });
            } else {
                // 普通网页环境，提示用户在小程序中打开
                notification.error({ message: '请在小程序中打开此页面' });
            }
        });
    }
    // 渲染消息内容
    function renderMessageContent(msg) {
        const { type, content } = msg;

        switch (type) {
            case 'text':
                return <Bubble content={content.text} />;
            case 'html':
                return (<div class='htmlMessage'><RichText content={content.html} /></div>);
            case 'image':
                return (
                    <Bubble type="image">
                        <img src={content.picUrl} alt="" />
                    </Bubble>
                );
            case 'typing':
                return (
                    <div className="Message-content">
                        <Typing text="" />
                    </div>
                );
            case 'miniProgram':
                return (
                    <Bubble>
                        <button
                            className="mini-program-button"
                            onClick={() => handleNavigateToMiniProgram(content.appId, content.path)}
                            disabled={!isWxReady}
                        >
                            {content.title || '打开小程序'}
                        </button>
                    </Bubble>
                );
            default:
                return null;
        }
    }

    // 调用接口获取消息列表
    function getMessageList() {
        // 调用接口获取消息列表
        // 假设接口返回的数据格式为：{ messages: [{ type: 'text', content: { text: 'Hello' } }] 

    }

    return (
        <Chat
            navbar={{ title: '悦生活助手' }}
            messages={messages}
            renderMessageContent={renderMessageContent}
            onQuickReplyClick={handleQuickReplyClick}
            onSend={(type, val) => {
                console.log(type, val);
                handleSend(type, val);
            }}
            quickReplies={defaultQuickReplies}
        />
    );
}